"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var PersonaCardBehavior_1 = require("owa-persona/lib/components/PersonaCardBehavior");
var React = require("react");
var styles = require('./PersonaPillWell.scss');
var PersonaPill = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaPill, _super);
    function PersonaPill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaPill.prototype.render = function () {
        return (React.createElement("div", { className: styles.personaPill, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave },
            React.createElement(PersonaControl_1.default, { name: this.props.name, emailAddress: this.props.emailAddress, size: Persona_1.PersonaSize.extraExtraSmall }),
            React.createElement("div", { className: styles.personaPillText }, this.props.name)));
    };
    PersonaPill = tslib_1.__decorate([
        PersonaCardBehavior_1.personaCardBehavior,
        mobx_react_1.observer
    ], PersonaPill);
    return PersonaPill;
}(React.Component));
exports.default = PersonaPill;
//# sourceMappingURL=PersonaPill.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-search-view/lib/components/PersonaPill.js
// module id = 4834
// module chunks = 37